module.exports = __webpack_public_path__ + "bce18c89255c73679685de8bc73c574e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/group_1.png
// module id = 62
// module chunks = 0